import modelBaseV2 from "../model-base-v2.model";

const EXPORT_FILE = {
	URL: '/api/executesp/export/file',
	STORED_PROCEDURE_CODE: {
		INTF_FILE_LEVEL_REPORT_DETAIL_EXPORT: '44',
		INTF_FILE_LEVEL_RAW_DATA_BY_STATUS: '45',
		INTF_FILE_LEVEL_SUMMARY: '46',
		INTF_FILE_LEVEL_DATE_VS_NO_OF_FILES: '47',
	},
	PARAM_CODE: {
		FROM_DATE: '8',
		TO_DATE: '9',
		STATUS: '23',
		CLIENT_CODE: '85',
		FILE_TYPE: '86',
		IS_PROCESSED: '87',
		FILE_NAME: '88',
		INCLUDE_UNKNOWN: '89'
	}
}

const MonitoringReportFileContentModel = {
	intfFileLevelFileDownload: (body, fileName = 'template') => modelBaseV2.postDownload("/api/intf-edi/IntfFileLevelFileDownload", { body }, fileName),
	getIntfFileType: () => modelBaseV2.get("/api/intf-edi/GetIntfFileType"),
	intfFileLevelReport: (body) => modelBaseV2.post("/api/intf-edi/IntfFileLevelReport", { body }),
	intfFileLevelReportDetail: (body) => modelBaseV2.post("/api/intf-edi/IntfFileLevelReportDetail", { body }),
	intfFileLevelReportDetailExport: (body, fileName = 'template') => {
		const exportConfig = {
			storedProcedureCode: EXPORT_FILE.STORED_PROCEDURE_CODE.INTF_FILE_LEVEL_REPORT_DETAIL_EXPORT,
			params: [
				{
					code: EXPORT_FILE.PARAM_CODE.CLIENT_CODE,
					value: body.clientCode,
				},
				{
					code: EXPORT_FILE.PARAM_CODE.FROM_DATE,
					value: body.fromDate,
				},
				{
					code: EXPORT_FILE.PARAM_CODE.TO_DATE,
					value: body.toDate,
				},
				{
					code: EXPORT_FILE.PARAM_CODE.FILE_TYPE,
					value: body.fileType,
				},
				{
					code: EXPORT_FILE.PARAM_CODE.FILE_NAME,
					value: body.fileName,
				},
				{
					code: EXPORT_FILE.PARAM_CODE.STATUS,
					value: body.status,
				},
			],
		};
		return modelBaseV2.postDownload(
			EXPORT_FILE.URL,
			{
				body: exportConfig,
			},
			fileName
		);
	},
	intfFileLevelRawDataByStatus: (body, fileName = 'template') => {
		const exportConfig = {
			storedProcedureCode: EXPORT_FILE.STORED_PROCEDURE_CODE.INTF_FILE_LEVEL_RAW_DATA_BY_STATUS,
			params: [
				{
					code: EXPORT_FILE.PARAM_CODE.CLIENT_CODE,
					value: body.clientCode,
				},
				{
					code: EXPORT_FILE.PARAM_CODE.FROM_DATE,
					value: body.fromDate,
				},
				{
					code: EXPORT_FILE.PARAM_CODE.TO_DATE,
					value: body.toDate,
				},
				{
					code: EXPORT_FILE.PARAM_CODE.FILE_TYPE,
					value: body.fileType,
				},
				{
					code: EXPORT_FILE.PARAM_CODE.STATUS,
					value: body.status,
				},
			],
		};
		return modelBaseV2.postDownload(
			EXPORT_FILE.URL,
			{
				body: exportConfig,
			},
			fileName
		);
	},
	intfFileLevelSummary: (body, fileName = 'template') => {
		const exportConfig = {
			storedProcedureCode: EXPORT_FILE.STORED_PROCEDURE_CODE.INTF_FILE_LEVEL_SUMMARY,
			params: [
				{
					code: EXPORT_FILE.PARAM_CODE.CLIENT_CODE,
					value: body.clientCode,
				},
				{
					code: EXPORT_FILE.PARAM_CODE.FROM_DATE,
					value: body.fromDate,
				},
				{
					code: EXPORT_FILE.PARAM_CODE.TO_DATE,
					value: body.toDate,
				},
				{
					code: EXPORT_FILE.PARAM_CODE.FILE_TYPE,
					value: body.fileType,
				},
				{
					code: EXPORT_FILE.PARAM_CODE.INCLUDE_UNKNOWN,
					value: body.includeUnknown ? 'Y' : 'N',
				},
			],
		};
		return modelBaseV2.postDownload(
			EXPORT_FILE.URL,
			{
				body: exportConfig,
			},
			fileName
		);
	},
	intfFileLevelDateVSNoOfFiles: (body, fileName = 'template') => modelBaseV2.postDownload("/api/intf-edi/IntfFileLevelDateVSNoOfFiles", { body }, fileName)
}

export default MonitoringReportFileContentModel;